export default {
  title: 'Introduce el importe del reembolso',
  description: 'Disponible para reembolso: {{amount}}',
  form: {
    amount: {
      label: 'Reembolsar',
    },
    reason: {
      label: 'Motivo',
      options: {
        requested_by_customer: 'solicitado por el cliente',
        reclamation: 'reclamación',
        communication_error: 'error de comunicación',
        other: 'otro',
      },
    },
    manual_reason: {
      label: 'Introduce el motivo del reembolso',
    },
  },
  feedback: {
    amount_too_small: 'Importe mínimo de reembolso {{amount}}',
    amount_too_big: 'Importe máximo de reembolso {{amount}}',
    payment_frozen:
      'Reembolso ya solicitado por el cliente. {{provider}} está en contacto con el cliente respecto al reembolso',
  },
  buttons: {
    refund: 'Reembolsar',
    cancel: 'Cancelar',
  },
  toasts: {
    refund_successful: '¡El reembolso de {{amount}} se inició correctamente!',
  },
};
